import StonecodeMailEditorMailTypeModel from '@models/website/StonecodeMailEditorMailTypeModel';
import doc                              from '@widesk-core/decorators/doc';
import WebsiteServiceModel              from '@/models/WebsiteServiceModel';
import Blamable                         from '@/models/traits/Blamable';
import { Addable }                      from '@widesk-core/decorators/addable';
import { Editable }                     from '@widesk-core/decorators/editable';
import { Deletable }                    from '@widesk-core/decorators/deletable';
import { Timestampable }                from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_mail_editor_mails/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractStonecodeMailEditorMailModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		partial: string;
	};

	declare private _tsSorts: {
		'id': string;
		'createdAt': string;
		'updatedAt': string;
		'label': string;
		'translations.subject': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Website_StonecodeMailEditorMailReference;
	@doc.model(StonecodeMailEditorMailTypeModel)
	declare mailType: StonecodeMailEditorMailTypeModel;
	@doc.string declare senderName: string;
	@doc.string declare mailFrom: string;
	@doc.string declare cc: string;
	@doc.string declare bcc: string;
	@doc.string declare template: string;
}

interface AbstractStonecodeMailEditorMailModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractStonecodeMailEditorMailModel;
